
// CORE MODULES
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule,APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { JoyrideModule } from 'ngx-joyride';

// APPLICATION ROUTING
import { AppRouting } from './app.routing';

// APPLCATION COMPONENTS
import { AppComponent } from './app.component';
import { HeaderMainComponent } from './components/header-main/header-main.component';
import { DataTableComponent } from './components/data-table/data-table.component';
import { UserLoginComponent } from './components/user-login/user-login.component';
import { DataPageComponent } from './components/data-page/data-page.component';
import { DataPagePOComponent } from './components/data-page-po/data-page-po.component';
import { DataPageContractorComponent } from './components/data-page-contractor/data-page-contractor.component';
import { PagePosComponent } from './components/page-pos/page-pos.component';
import { PageContractorsComponent } from './components/page-contractors/page-contractors.component';
import { PageTimesheetsComponent } from './components/page-timesheets/page-timesheets.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { AdminPOComponent } from './components/admin-po/admin-po.component';
import { UiTabsComponent } from './components/ui-tabs/ui-tabs.component';
import { UserLogoutComponent } from './components/user-logout/user-logout.component';
import { DataPageTimesheetComponent } from './components/data-page-timesheet/data-page-timesheet.component';
import { TimesheetRowComponent } from './components/timesheet-row/timesheet-row.component';
import { UiActionListComponent } from './components/ui-action-list/ui-action-list.component';
import { ModalFormComponent } from './components/modal-form/modal-form.component';
import { DataPageUserComponent } from './components/data-page-user/data-page-user.component';
import { UserLandingComponent } from './components/user-landing/user-landing.component';
import { PageSmartContractsComponent } from './components/page-smart-contracts/page-smart-contracts.component';
import { FileListComponent } from './components/file-list/file-list.component';
import { PagePoReplacementComponent } from './components/page-po-replacement/page-po-replacement';
import { AdminAddonsComponent } from './components/admin-addons/admin-addons.component';
import { AddonFieldComponent } from './components/addon-field/addon-field.component';
import { PageInvoicesComponent } from './components/page-invoices/page-invoices.component';
import { PrivacyNoticeComponent } from './components/privacy-notice/privacy-notice.component';
import { AdminInvoiceComponent } from './components/admin-invoice/admin-invoice.component';
import { TimesheetLineItemsComponent } from './components/timesheet-line-item/timesheet-line-item.component';
import { TimesheetExpensesComponent } from './components/timesheet-expenses/timesheet-expenses.component';
import { DataModalComponent } from './components/data-modal/data-modal.component';
import { AdminUsersComponent } from './components/admin-users/admin-users.component';
import { UserAcceptComponent } from './components/user-accept/user-accept.component';
import { PageInvoiceCalendarsComponent } from './components/page-invoice-calendars/page-invoice-calendars.component';
import { UiDateArrayComponent } from './components/ui-date-array/ui-date-array.component';
import { DataModalPocontractorComponent } from './components/data-modal-pocontractor/data-modal-pocontractor.component';
import { DataModalAddUserComponent } from './components/data-modal-add-user/data-modal-add-user.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { HelpComponent } from './components/help/help.component';
import { AdminSupInvoiceComponent } from './components/admin-sup-invoice/admin-sup-invoice.component';
import { InvoiceCalendarEntriesComponent } from './components/invoice-calendar-entries/invoice-calendar-entries.component';
import { DataModalPartialSuccessComponent } from './components/data-modal-partial-success/data-modal-partial-success.component';
import { DataModalMergeContractorComponent } from './components/data-modal-merge-contractor/data-modal-merge-contractor.component';
import { DataModalExportComponent } from './components/data-modal-export/data-modal-export.component';
import { ModalFormMigrateTimesheetsComponent } from './components/modal-form-migrate-timesheets/modal-form-migrate-timesheets.component';
import { UserConfigComponent } from './components/user-config/user-config.component';
import { PageSupplierInvoicesComponent } from './components/page-supplier-invoices/page-supplier-invoices.component';
import { TimesheetRowSearchableComponent } from './components/timesheet-row-searchable/timesheet-row-searchable.component';
import { SearchAccountsComponent } from './components/search-accounts/search-accounts.component';
import { PageReportsComponent } from './components/page-reports/page-reports.component';
import { SaConfigComponent } from './components/sa-config/sa-config.component';
import { UiDateTimeComponent } from './components/ui-date-time/ui-date-time.component';
import { UiDayTimeComponent } from './components/ui-day-time/ui-day-time.component';
import { PageBlockchainInvoicesComponent } from './components/page-blockchain-invoices/page-blockchain-invoices.component';
import { PageDtvScheduleComponent } from './components/page-dtv-schedule/page-dtv-schedule.component';
import { ReleaseNotesComponent } from './components/release-notes/release-notes.component';
import { PageContainerComponent } from './components/page-container/page-container.component';
import { NoteComponent } from './components/note/note.component';
import { TableFilterComponent } from './components/table-filter/table-filter.component';
import { TableFilterFieldTextComponent } from './components/table-filter-field-text/table-filter-field-text.component';
import { TableFilterFieldBooleanComponent } from './components/table-filter-field-boolean/table-filter-field-boolean.component';
import { TableFilterFieldSelectComponent } from './components/table-filter-field-select/table-filter-field-select.component';
import { TableFilterFieldDateComponent } from './components/table-filter-field-date/table-filter-field-date.component';
import { TableFilterFieldNumberComponent } from './components/table-filter-field-number/table-filter-field-number.component';
import { DataFormComponent } from './components/data-form/data-form.component';
import { DataFormFieldTextComponent } from './components/data-form-field-text/data-form-field-text.component';
import { DataFormFieldSelectComponent } from './components/data-form-field-select/data-form-field-select.component';
import { DataModalContractorSubmissionComponent } from './components/data-modal-contractor-submission/data-modal-contractor-submission.component';

// APPLCATION DIRECTIVES
import { PasswordValidatorDirective } from './services/validation/validation.service';

// 3RD PARTY COMPONENTS
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { CookieService } from 'ngx-cookie-service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import {
	UIShellModule,
	DropdownModule,
	NotificationModule,
	NFormsModule,
	DialogModule,
	ButtonModule,
	DatePickerModule,
	AccordionModule,
	CheckboxModule,
	IconModule,
	ComboBoxModule,
	SelectModule,
	InputModule,
	ModalModule,
	GridModule,
	ProgressIndicatorModule
} from 'carbon-components-angular';

// APPLICATION SERVICES
import { UserService } from './services/user/user.service';
import { CommsService } from './services/comms/comms.service';
import { DataService } from './services/data/data.service';
import { NoteService } from './services/note/note.service';
import { NotificationService } from './services/notification/notification.service';
import { SearchService } from './services/search/search.service';
import { ConfigService } from './services/config/config.service';
import { PurchaseOrderService } from './services/purchase-order/purchase-order.service';
import { ContractorService } from './services/contractor/contractor.service';
import { TimesheetService } from './services/timesheet/timesheet.service';
import { DisplayService } from './services/display/display.service';
import { AccountService } from './services/account/account.service';
import { ValidationService } from './services/validation/validation.service';
import { SmartContractService } from './services/smart-contract/smart-contract.service';
import { FileService } from './services/file/file.service';
import { AddonService } from './services/addon/addon.service';
import { InvoiceService } from './services/invoice/invoice.service';
import { SocketService } from './services/socket/socket.service';
import { TabService } from './services/tab/tab.service';
import { HelpService } from './services/help/help.service';
import { CalendarService } from './services/calendar/calendar.service';
import { SettingsService } from './services/settings/settings.service';
import { DtvScheduleService } from './services/dtv-schedule/dtv-schedule.service';
import { TimesheetRowCalculatedComponent } from './components/timesheet-row-calculated/timesheet-row-calculated.component';
import { UiFontSwitchComponent } from './components/ui-font-switch/ui-font-switch.component';
import { DataPageFieldsEditComponent } from './components/data-page/data-page-fields-edit/data-page-fields-edit.component';
import { DataPageSupplierInvoiceComponent } from './components/data-page-supplier-invoice/data-page-supplier-invoice.component';
import { DataPageBcinvoiceComponent } from './components/data-page-bcinvoice/data-page-bcinvoice.component';
import { ModalFormMigratePoComponent } from './components/modal-form-migrate-po/modal-form-migrate-po.component';
import { ReportService } from './services/report/report.service';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DashboardWidgetComponent } from './components/dashboard-widget/dashboard-widget.component';
import { DashboardActionWidgetComponent } from './components/dashboard-action-widget/dashboard-action-widget.component';
import { DataTableService } from './services/dataTable/dataTable.service';
import { TableFilterService } from './services/table-filter/table-filter.service';
import { DataPageInvoiceComponent } from './components/data-page-invoice/data-page-invoice.component';
import { DataFormService } from './services/data-form/data-form.service';
import { LoginHelpComponent } from './components/login-help/login-help.component';
import { DataFormFieldBooleanComponent } from './components/data-form-field-boolean/data-form-field-boolean.component';
import { DataFormFieldDateComponent } from './components/data-form-field-date/data-form-field-date.component';
import { DateJumpToComponent } from './components/date-jump-to/date-jump-to.component';
import { TimesheetLocalizationService } from './services/timesheet-localization/timesheet-localization.service';
import { ContractorDetailComponent } from './components/contractor-detail/contractor-detail.component';
import { TimesheetHourFieldComponent } from './components/timesheet-hour-field/timesheet-hour-field.component';
import { DataFormFieldComboBoxComponent } from './components/data-form-field-combo-box/data-form-field-combo-box.component';
import { TimesheetProgressComponent } from './components/timesheet-progress/timesheet-progress.component';
import { EnvService } from '../config/env.service';
@NgModule({
	declarations: [
		AppComponent,
		HeaderMainComponent,
		DataTableComponent,
		UserLoginComponent,
		DataPageComponent,
		DataPagePOComponent,
		DataPageContractorComponent,
		PagePosComponent,
		PageContractorsComponent,
		PageTimesheetsComponent,
		FileUploadComponent,
		AdminPOComponent,
		UiTabsComponent,
		UserLogoutComponent,
		DataPageTimesheetComponent,
		TimesheetRowComponent,
		UiActionListComponent,
		ModalFormComponent,
		DataPageUserComponent,
		UserLandingComponent,
		PageSmartContractsComponent,
		FileListComponent,
		PagePoReplacementComponent,
		AdminAddonsComponent,
		AddonFieldComponent,
		PageInvoicesComponent,
		PrivacyNoticeComponent,
		AdminInvoiceComponent,
		TimesheetLineItemsComponent,
		TimesheetExpensesComponent,
		DataModalComponent,
		AdminUsersComponent,
		UserAcceptComponent,
		PasswordValidatorDirective,
		PageInvoiceCalendarsComponent,
		UiDateArrayComponent,
		DataModalPocontractorComponent,
		DataModalMergeContractorComponent,
		DataModalAddUserComponent,
		ResetPasswordComponent,
		HelpComponent,
		AdminSupInvoiceComponent,
		InvoiceCalendarEntriesComponent,
		DataModalPartialSuccessComponent,
		DataModalExportComponent,
		ModalFormMigrateTimesheetsComponent,
		UserConfigComponent,
		PageSupplierInvoicesComponent,
		TimesheetRowSearchableComponent,
		SearchAccountsComponent,
		PageReportsComponent,
		SaConfigComponent,
		UiDateTimeComponent,
		UiDayTimeComponent,
		PageBlockchainInvoicesComponent,
		TimesheetRowCalculatedComponent,
		UiFontSwitchComponent,
		DataPageFieldsEditComponent,
		DataPageSupplierInvoiceComponent,
		DataPageBcinvoiceComponent,
		PageDtvScheduleComponent,
		ModalFormMigratePoComponent,
		DashboardComponent,
		DashboardWidgetComponent,
		DashboardActionWidgetComponent,
		ReleaseNotesComponent,
		PageContainerComponent,
		NoteComponent,
		TableFilterComponent,
		TableFilterFieldBooleanComponent,
		TableFilterFieldTextComponent,
		TableFilterFieldSelectComponent,
		TableFilterFieldDateComponent,
		TableFilterFieldNumberComponent,
		DataPageInvoiceComponent,
		LoginHelpComponent,
		DataFormComponent,
		DataFormFieldTextComponent,
		DataFormFieldSelectComponent,
		DataFormFieldBooleanComponent,
		DataFormFieldDateComponent,
		DataFormFieldComboBoxComponent,
		DateJumpToComponent,
		ContractorDetailComponent,
		TimesheetHourFieldComponent,
		DataModalContractorSubmissionComponent,
		TimesheetProgressComponent
	],
	imports: [
		JoyrideModule.forRoot(),
		// JoyrideModule.forChild(),
		// NgbModule.forRoot(),
		NgbModule,
		AppRouting,
		BrowserModule,
		BrowserAnimationsModule,
		FormsModule,
		ReactiveFormsModule,
		NgxDatatableModule,
		HttpClientModule,
		NgIdleKeepaliveModule.forRoot(),
		UIShellModule,
		DropdownModule,
		NotificationModule,
		NFormsModule,
		DialogModule,
		ButtonModule,
		DatePickerModule,
		AccordionModule,
		IconModule,
		CheckboxModule,
		ComboBoxModule,
		SelectModule,
		InputModule,
		ModalModule,
		GridModule,
		ProgressIndicatorModule
	],
	providers: [
		CookieService,
		UserService,
		CommsService,
		DataService,
		NoteService,
		NotificationService,
		SearchService,
		ConfigService,
		PurchaseOrderService,
		ContractorService,
		TimesheetService,
		DisplayService,
		AccountService,
		ValidationService,
		SmartContractService,
		FileService,
		AddonService,
		InvoiceService,
		SocketService,
		TabService,
		HelpService,
		CalendarService,
		SettingsService,
		DtvScheduleService,
		ReportService,
		DataTableService,
		TableFilterService,
		DataFormService,
		TimesheetLocalizationService,
		EnvService,
		{ provide: APP_INITIALIZER, useFactory: loadEnvFactory, deps: [EnvService], multi: true },
	],
	bootstrap: [
		AppComponent
	]
})
export class AppModule { }
export function loadEnvFactory(provider: EnvService) {
	return () => provider.loadUIConfig();
}